const STORAGE_NAME_REGEX = /^[a-zA-Z0-9_]+$/;

export default {
  REQUEST_NAME: 'urlParameters',
  SINGLE_SELECT_DESCRIPTION: 'URL Parameters',
  REQUEST_INPUT_NAME: 'urlParameters',
  DESCRIPTION:
    'Collects multiple URL parameters form the page URL and sends them to the server. Each URL parameter can be stored for X amount of time.',
  FIELDS: [
    {
      type: 'TEXT',
      property: 'parameter',
      title: 'Parameter Name',
      description: 'URL parameter in the query string',
      required: true,
      default: '',
      placeholder: 'e.g., gclid',
    },
    {
      type: 'NUMBER',
      property: 'timeToLive',
      title: 'Lifetime (in days)',
      description: 'How long do you want this parameter to exists even if it is not present in the URL?',
      required: true,
      default: 14,
      placeholder: 14,
    },
    {
      type: 'BOOL',
      property: 'override',
      title: 'Override on revisit',
      description:
        'When ON, a new URL value replaces the stored value on every visit. When OFF, the first value seen is kept (first-touch attribution).',
      required: false,
      default: true,
    },
    {
      type: 'BOOL',
      property: 'includeTimestamp',
      title: 'Include timestamp',
      description:
        'When ON, also saves the time (in milliseconds) the value was stored, under a key of "{storageName}_timestamp".',
      required: false,
      default: false,
    },
    {
      type: 'BOOL',
      property: 'useStorageName',
      title: 'Use Different Storage Name',
      description: 'When ON, saves the value under a custom storage key name instead of the parameter name.',
      required: false,
      default: false,
    },
    {
      type: 'TEXT',
      property: 'storageName',
      title: 'Storage Name',
      description:
        'Storage key name (letters, numbers, underscores only). The URL value is still read using the Parameter Name above.',
      required: false,
      default: '',
      placeholder: 'e.g., my_custom_key',
      dependsOn: 'useStorageName',
      validate: value => (STORAGE_NAME_REGEX.test(value) ? null : 'Only letters, numbers, and underscores are allowed'),
    },
  ],
};
